export enum ExamResultsYesNoEnum {
  YES = 'TRUE',
  NO = 'FALSE',
}
